<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>
            <a-descriptions-item label="交易单号">{{ form.id }}</a-descriptions-item>
            <a-descriptions-item label="交易状态">
                <dict-render :dict-obj="dictObjs['transaction_status']" :text="form.transactionStatus"
                             v-if="form.transactionStatus"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="产权名称">{{ form.propertyNames }}</a-descriptions-item>
            <a-descriptions-item label="产权所属名称">
                <span v-html="form.userName"></span>
            </a-descriptions-item>
            <a-descriptions-item label="出售方名称">
                <span v-html="form.sellerName"></span>
            </a-descriptions-item>
            <a-descriptions-item label="出售方联系方式">
                <span v-html="form.sellerPhone"></span>
            </a-descriptions-item>
            <a-descriptions-item label="产权类型">
                <dict-render :dict-obj="dictObjs['property_type']" :text="form.propertyType"
                             v-if="form.propertyType"></dict-render>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="交易价格">
                <span v-html="form.price"></span>
            </a-descriptions-item>
            <a-descriptions-item label="价格类型">
                <dict-render :dict-obj="dictObjs['priceType']" :text="form.priceType"
                             v-if="form.priceType"></dict-render>
            </a-descriptions-item> -->


            <a-descriptions-item label="交易方式">
                <dict-render :dict-obj="dictObjs['tradeMode']" :text="form.tradeMode"
                             v-if="form.tradeMode"></dict-render>
            </a-descriptions-item>


            <a-descriptions-item label="交易审核状态">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="form.auditStatus"
                             v-if="form.auditStatus"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="交易审核时间">
                <span v-html="form.auditTime"></span>
            </a-descriptions-item>
            <a-descriptions-item label="交易完成时间">
                <span v-html="form.transactionCompletionTime"></span>
            </a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {DictRender},
        data() {
            return {
                dictNames: "demand_type,aduit_status,property_type,priceType,tradeMode,transaction_status",
                form: {
                    id: null,
                    brandName: null,
                    sellerName: null,
                    sellerPhone: null,
                    transactionStatus:null,
                    transactionCompletionTime:null,
                    auditTime: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
